import React from "react";
import {Picker} from "../../Utils/Picker";


export default function DepartmentSelector({name, label, value, onChange, options, blank, disabled, classname, inlineEdit, onSave, editable, setEditable}){

    return (
        <Picker
            name={name}
            label={label}
            value={value}
            onSave={onSave}
            onChange={onChange}
            options={options}
            optionField={"name"}
            blank={blank}
            disabled={disabled}
            className={classname}
            inlineEdit={inlineEdit}
            editable={editable}
            setEditable={setEditable}
        />
    )


}